import styled from 'styled-components'
import React from 'react'

const ToContact = styled.span`
  font-size: 0.725rem;
  padding-bottom: 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export default ToContact
